module.exports = __webpack_public_path__ + "assets/img/news2.2.98bc0b77.png";